"use client";
import { FullscreenIcon } from "lucide-react";
import React, { useState } from "react";
import { Button } from "../ui/button";
import useIsMounted from "@/hooks/useIsMounted";

const FullScreenToggle = () => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const isMounted = useIsMounted()

  if (!isMounted) return null
  return (
    <Button size="icon">
      <FullscreenIcon
        onClick={() => {
          if (!isFullScreen) {
            setIsFullScreen(true);
            document.documentElement.requestFullscreen();
          } else {
            setIsFullScreen(false);
            document.exitFullscreen();
          }
        }}
      />
    </Button>
  );
};

export default FullScreenToggle;
